import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'Sarah M.',
  role: 'Spanish Teacher | Austin, Texas',
  text: '"My students finally stopped confusing ser and estar. Before this, I was spending my Sundays searching for ways to explain basic grammar. Now I walk into class with everything ready."'
}, {
  initials: 'JR',
  name: 'James R.',
  role: 'Spanish Teacher | London, UK',
  text: '"I never improvise anymore. The lesson plans do the heavy lifting for me. I finally have my weekends back."'
}, {
  initials: 'PL',
  name: 'Patricia L.',
  role: 'Spanish Teacher | Toronto, Canada',
  text: '"The cultural units changed everything. My heritage speakers finally feel seen in my classroom. And my reluctant learners are actually engaged. I didn\'t think that was possible."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-navy border-y border-navy-light" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4" data-id="element-267">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-268">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-navy-dark border border-navy-light/50 p-6 rounded-2xl relative" data-id="element-269">
              <div className="flex gap-1 text-gold mb-4" data-id="element-270">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-271" />)}
              </div>
              <p className="text-white italic mb-6 text-sm leading-relaxed" data-id="element-272">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-273">
                <div className="w-10 h-10 rounded-full bg-turquoise/10 border border-turquoise flex items-center justify-center text-turquoise font-bold" data-id="element-274">
                  {t.initials}
                </div>
                <div data-id="element-275">
                  <div className="font-bold text-white text-sm" data-id="element-276">{t.name}</div>
                  <div className="text-xs text-turquoise" data-id="element-277">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}